import ProductBox from '~/themes/base/components/product/ProductBox'

export default {
  mixins: [ProductBox],
}
